import { useContextSelector } from "use-context-selector";
import { AuthenticationContext } from "../providers/authentication";

const useIsAuthenticated = () => {
  return useContextSelector(AuthenticationContext, c => c.isAuthenticated);
};

export default useIsAuthenticated;
